import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthState, LoginData } from '../../types/auth.types';

const loadAuthFromLocalStorage = (): LoginData | null => {
  try {
    const serializedAuth = localStorage.getItem('authData');
    if (serializedAuth === null) {
      return null;
    }
    const parsed = JSON.parse(serializedAuth);
    // Migrate legacy entries that lack the permissions field
    if (!Array.isArray(parsed.permissions)) {
      parsed.permissions = [];
    }
    return parsed;
  } catch (err) {
    return null;
  }
};

const initialState: AuthState = {
  isAuthenticated: !!loadAuthFromLocalStorage(),
  user: loadAuthFromLocalStorage(),
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    loginSuccess: (state, action: PayloadAction<LoginData>) => {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.loading = false;
      state.error = null;

      // Guardar en localStorage
      localStorage.setItem('authData', JSON.stringify(action.payload));
    },
    loginFailure: (state, action: PayloadAction<string>) => {
      state.isAuthenticated = false;
      state.user = null;
      state.loading = false;
      state.error = action.payload;

      // Limpiar localStorage
      localStorage.removeItem('authData');
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.loading = false;
      state.error = null;

      // Limpiar localStorage
      localStorage.removeItem('authData');
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { setLoading, loginSuccess, loginFailure, logout, clearError } = authSlice.actions;
export default authSlice.reducer;
